import React, { useState } from 'react';
import axios from '../helpers/axiosConfig';
import BrigadesPieChart from './BrigadePieChart';

const MadagascarMap = () => {
  const [tooltip, setTooltip] = useState({
    display: false,
    data: {},
    x: 0,
    y: 0,
  });

  // Fonction pour récupérer les données depuis le backend
  const fetchData = async (id) => {
    try {
      const response = await axios.get(`brigade/stats/${id}`);
      const result = await response.data;

      return result; // Suppose que les données sont retournées directement
    } catch (error) {
      console.error('Erreur lors de la récupération des données:', error);
      return {};
    }
  };

  // Fonction pour afficher l'infobulle
  const showTooltip = async (event, id) => {
    const data = await fetchData(id);
    setTooltip({
      display: true,
      data: data,
      x: event.clientX,
      y: event.clientY,
    });
  };

  // Fonction pour cacher l'infobulle
  const hideTooltip = () => {
    setTooltip({
      ...tooltip,
      display: false,
    });
  };

  return (
    <div className="">
      <div className="row">
        <div className="col bg-success text-center p-3 ">
          <h1>STATISTIQUE PAR BRIGADE</h1>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <svg xmlns="http://www.w3.org/2000/svg" width="800" height="auto" viewBox="0 0 800 1200">
            {/* Zone pour Brigade Centre */}
            <a href="/brigade/10/effectifbrigade" onMouseOver={(e) => showTooltip(e, 10)} onMouseOut={hideTooltip}>
              <path
                d="M541.132,27.13l-2.524,3.649l-2.244,0.558l-3.368,3.367l0.562,1.681
		l4.486,2.246l-1.405,3.364l-3.643,2.246l-1.118,5.328h-6.454l1.119,7.852l-3.646,1.404l-3.928-2.803l-3.081-3.368l-4.206,2.805
		l0.274,1.682l5.051,2.526l2.247,2.803l0.557,4.209l5.049,14.586l-2.07,5.465l-2.977,4.072l-1.961,1.119l1.117,10.378l-3.363,3.087
		l0.282,5.326l-5.049-0.84l-3.087,2.523l-4.768-0.844h-2.804l-0.275,5.611h-5.336l-3.368-1.119l-0.274,13.461l-3.367,1.964h-3.644
		l-3.086-5.327l0.563-5.611l-10.658-4.77l-2.807,6.173l-0.28,4.764l-3.367,3.087v4.207l2.524,2.805l5.049,1.968l-1.118,4.487v2.804
		l2.799,0.282l3.367-4.769l2.526-2.247l4.773-1.399h2.523l-2.249,5.892l3.931,4.488l5.324,2.802l4.372,2.601l15.82,2.449
		l4.213,1.964l4.767-4.769l9.723,1.671l3.181,6.744l7.852,7.853l3.927,2.803v5.89l2.523,3.65v3.922l2.244,4.21l13.183,14.022
		l4.212-0.563l2.237,8.7l4.775,3.365l5.885,0.841v7.856l-3.643,10.095l4.203,17.39l6.738,5.608l7.568-8.973l6.732-20.195
		l2.523-5.048l-0.282-10.38l-10.657-21.874l-3.648-12.341v-10.658l-1.399-10.659l-1.124-16.544l-2.241-6.17l3.083-1.686
		l-2.525-3.925l-1.4-5.613l-2.525-4.485l-1.965-6.732l-1.401-7.571l-2.525-6.168l-0.28-10.658l-5.329-5.331l-3.084-4.769
		l-3.645-3.367h-1.405l-0.56-4.767l-4.206-6.172l-0.285-8.974l-4.487-0.284l-5.609-7.009h-6.729l-1.401-2.246l1.401-3.082h5.608
		l0.564-2.524L545.9,32.47l-3.365-4.769L541.132,27.13z"
                fill="#ff9999"
                stroke="#000"
                stroke-width="2"
              >
                <title>Brigade D'INFENTERIE NORD</title>
              </path>
            </a>
            <a href="/brigade/9/effectifbrigade" onMouseOver={(e) => showTooltip(e, 9)} onMouseOut={hideTooltip}>
              <path
                d="M303.289,267.638l4.205,7.151l2.107,10.097l10.094,7.995l4.208,4.205
		l5.048,13.465l7.574-1.685l-0.841,4.208l0.421,12.623l2.524,7.991l-1.684,3.788l15.566,0.842l7.149-0.421l2.103,20.195l6.735-0.841
		l2.521,2.526l4.628-0.422l14.727-6.311h14.302l1.683,5.048l10.939,1.263l8.414-4.628h9.677l5.05,6.73l6.729-0.418l8.833-5.471
		l8.418-1.262l2.943,5.05l2.944-6.732l3.366-3.365l-3.786-5.89l-1.265-6.311l6.73-2.946l6.737-11.78l-1.263-6.312l-3.368,0.843
		l-2.107-3.368l-0.416-5.048l-5.47-9.676l-2.948-11.78l2.522-13.042l7.155-4.629l11.357,0.421l4.631,2.524l10.099,7.573l4.205,7.149
		l1.681,6.732l12.62,0.42l3.366-2.523v-5.049l5.895-2.523l6.729-8.834l0.844-9.256l2.524-5.049l-7.15-9.257l-5.894-10.934
		l3.785-7.154v-6.729l-3.785-2.106l-0.839-5.468l13.198-4.303l5.731-0.748l2.525-9.675l4.624-0.422v-14.023l-2.242-4.207v-3.923
		l-2.522-3.65v-5.892l-3.926-2.803l-3.086-3.365l-4.766-4.487l-4.214-7.016l-8.692-1.4l-4.765,4.767l-4.212-1.964l-15.821-2.448
		l-9.696-5.402l-3.932-4.487l2.247-5.893l-7.293,1.4l-5.896,7.015l0,0l1.962,2.397l-1.4,14.572l-3.785,0.84l-1.684-7.572
		l-4.628-5.89l-2.525,3.364l-1.262,6.732l-7.149,2.526l1.264,6.312l2.941,1.26l-1.262,10.098l-2.943,6.732l-3.786,5.889l-2.949,6.31
		l-6.311,7.572l0.846-7.572l-0.422-5.47l4.206-3.365v-7.994l-2.106-3.367l-5.88,4.854l-5.057,4.822l2.944,4.628l-7.148,7.152
		l-5.893,5.469l-0.422,4.626l3.368,1.262l1.685,3.788l-0.422,6.729l-1.113,4.708l-9.826-3.026l4.208-6.31l-5.89-8.835l-5.891,5.468
		l-21.035,12.621l-3.786,7.153l2.104,3.365l-1.262,10.938l-0.841,1.683l-5.469-0.421l1.262-7.152l-1.262-5.889l-16.409,5.468
		l-5.468,3.787l-3.788-0.419l-3.787-2.947l-5.891,1.264l0.421,7.149l-2.104,5.051l-2.104,0.842l-3.786-4.209l-4.622-0.408
		l-0.422,7.57l-5.049,3.368l-1.681-10.518l-7.572,1.683l-5.471,7.151L303.289,267.638z"
                fill="#ccccff"
                stroke="#000"
                stroke-width="2"
              >
                 <title>BRIGADE INFANTERIE NORD OUEST</title> 
              </path>
            </a>

            <a href="/brigade/13/effectifbrigade" onMouseOver={(e) => showTooltip(e, 13)} onMouseOut={hideTooltip}>
              <path
                d="M257.143,588.116c-1.15-0.228-3.441-3.476-8.095-11.484
		c-3.567-6.138-7.993-12.838-9.83-14.88c-4.084-4.541-3.725-5.009,4.507-5.879l5.987-0.635l0.873-3.943
		c0.481-2.17,1.417-5.3,2.081-6.956c0.724-1.809,1.205-5.216,1.205-8.525v-5.512l3.005-2.081c3.948-2.735,5.751-5.828,6.375-10.931
		c0.465-3.782,0.966-4.677,5.282-9.456c2.774-3.066,5.358-6.812,6.183-8.952c0.778-2.022,3.498-7.171,6.043-11.436
		c2.544-4.27,4.627-8.064,4.627-8.433c0-0.365-1.182-2.509-2.625-4.77c-3.163-4.938-3.484-9.705-1.127-16.559
		c0.826-2.401,1.501-5.107,1.501-6.021c0-3.022-3.253-9.676-6.776-13.868c-4.588-5.448-5.52-8.83-5.584-20.258
		c-0.052-8.877-0.179-9.647-2.397-14.37c-1.523-3.249-2.909-5.168-3.978-5.506c-3.35-1.067-4.398-5.739-5.347-23.834
		c-0.847-16.235-0.923-16.754-2.76-18.727c-1.845-1.979-1.878-2.221-1.484-10.505c0.494-10.313,1.574-13.08,8.996-23.03
		c6.833-9.159,14.251-24.088,15.88-31.972c1.135-5.481,1.133-6.191-0.01-9.631c-1.061-3.188-1.103-4.315-0.303-7.927
		c0.511-2.315,1.083-4.466,1.271-4.782c0.19-0.315,1.675,0.222,3.307,1.193c2.849,1.699,3.162,1.729,8.015,0.791
		c8.041-1.555,8.466-1.457,11.495,2.724c1.944,2.683,2.953,5.129,3.633,8.794l0.944,5.083l7.264,6.139l7.264,6.135l2.608,7.213
		c2.825,7.811,2.424,7.501,7.675,5.94c1.184-0.354,1.312,0.289,1.312,6.486c0,4.082,0.486,8.557,1.2,11.002
		c1.141,3.929,1.136,5.842-0.024,8.585c-0.736,1.74,1.42,2.114,12.983,2.252c5.417,0.067,9.869,0.325,9.89,0.573
		c0.019,0.249,0.466,4.338,0.991,9.084c0.823,7.407,0.797,9.225-0.164,12.831l-1.121,4.2l-4.884,1.803
		c-4.19,1.548-5.422,2.465-8.688,6.476c-2.094,2.569-4.396,4.681-5.118,4.69c-1.62,0.021-1.64,1.168-0.117,7.036
		c1.689,6.518,0.911,14.66-1.627,17.046c-1.661,1.56-1.82,2.29-1.82,8.398c0,6.293,0.161,6.975,2.729,11.565
		c1.499,2.682,3.49,7.286,4.424,10.234c1.812,5.713,1.337,5.31,8.042,6.828c1.913,0.433,2.063,0.743,2.063,4.205v3.739h-3.376
		c-1.875,0-3.378,0.354-3.378,0.794c0,3.109,2.037,8.193,4.192,10.461c2.394,2.53,2.46,2.757,1.729,6.005
		c-0.418,1.859-0.551,4.505-0.293,5.891c0.341,1.82,0.117,2.902-0.813,3.934c-1.122,1.238-1.217,2.487-0.769,9.867
		c0.284,4.649,1.306,14.189,2.273,21.205c1.725,12.533,1.731,12.794,0.345,14.753c-0.8,1.128-1.41,3.258-1.41,4.913
		c0,3.183-1.035,4.724-3.168,4.724c-0.753,0-2.834,1.352-4.625,3.003c-1.792,1.649-3.894,3.008-4.673,3.011
		c-3.15,0.02-4.928,1.063-6.249,3.65c-2.088,4.092-4.101,5.621-6.711,5.098c-1.759-0.352-2.902,0.095-5.627,2.172
		c-1.881,1.435-4.93,3.256-6.773,4.051l-3.352,1.433l-3.402-2.599c-2.969-2.264-4.174-2.67-9.426-3.18
		c-3.317-0.319-6.024-0.34-6.024-0.043c0,0.295,0.701,2.174,1.555,4.164c1.431,3.328,1.491,4.112,0.697,9.531
		c-0.853,5.841-0.835,5.966,1.578,11.813c1.341,3.249,2.269,6.073,2.062,6.285c-0.21,0.207-4.352,1.415-9.201,2.684
		c-7.262,1.898-9.231,2.168-11.126,1.508c-1.265-0.443-4.268-0.802-6.678-0.802c-4.279,0-4.424,0.066-6.365,3.002
		C261.935,588.622,261.169,588.898,257.143,588.116L257.143,588.116z"
                fill="#828220"
                stroke="#000"
                stroke-width="2"
              >
                <title>BRIGADE D'INFANTERIE OUEST</title> 
              </path>
            </a>

            <a href="/brigade/14/effectifbrigade" onMouseOver={(e) => showTooltip(e, 14)} onMouseOut={hideTooltip}>
              <path
                id="path5416"
                fill="#532814"
                stroke="#000000"
                d="M289.406,780.272l2.521-7.783l6.103-6.731l6.731-4.836l7.572-6.943
		l3.997-5.678l0.418-6.522l2.525-3.152l-2.525-10.311l6.104-9.681l-2.628-9.361l3.048-4.52v-4.414l4.626-5.261l8.624-1.687
		l2.315-9.041l-3.157-6.522h-10.726l-0.421-3.368l2.313-6.311l4.628-4.207l-0.418-7.991l0.838-9.258l5.048-7.15l13.256-5.891
		l13.249-1.685l16.41,14.1l1.055,8.619l8.202,5.472l0.842,11.778l-3.367,1.896l-0.629,5.674l4.629,1.899l1.049,1.682l7.992,0.839
		l0.631,3.366l4.211,0.634l5.046-4l-0.842-1.053l3.788-14.089l-3.37-5.261l1.263-6.099l-3.998-6.104l0.212-4.206l7.701-1.65
		l7.868,2.285l2.312,4.415l3.575-10.308l0.213-17.878l-2.738-10.522l-3.361-4.416l-0.211-5.254l-17.04,2.101l-6.731-4.836
		L392.898,600l-5.679-5.049v-8.208l-8.627-5.676l-8.204-1.685l-13.882-0.842l-18.093-8.206l2.947-9.673l0.882-7.924l9.004-2.175
		l-0.209-7.785l2.738-3.574l-1.264-7.57l-6.104,1.26l-4.416,5.049l-6.521,1.051l-2.947,5.048l-3.787,3.574l-4.627-0.627
		l-6.312,4.624l-7.573,3.576l-7.572-5.676l-9.257-0.844l2.737,6.311l-1.681,11.778l4.627,11.359l0.211,2.526l-20.191,5.261
		l-4.211-1.473l-7.995-0.212l-4.417,6.103l-7.783-0.844l-12.623-21.668l-4.414-5.675l-5.047-4.211l-2.325,1.716l0.854,17.005
		l-6.102,5.262l-5.472,20.822l0.502,15.94l2.654,3.416v9.45l7.991,13.056l3.549,9.766l5.708,2.015l3.368,13.047l5.258,8.834
		l-0.629,6.516l-5.048,2.525l1.892,25.241l1.682,9.048l-0.209,9.255l13.671,13.463l0.211,7.782l5.471,6.735L265,766.176
		l14.516,5.681l2.312,6.729L289.406,780.272z"
              />
             <title>BRIGADE D'INFANTERIE SUD-OUEST</title> 
            </a>

            <a href="/brigade/15/effectifbrigade" onMouseOver={(e) => showTooltip(e, 15)} onMouseOut={hideTooltip}>
              <path
                id="path5416"
                fill="#293488"
                stroke="#000000"
                d="M500.179,507.023l-10.097-8.836l-10.095-4.209l-5.468,9.26l-17.673,3.361
		l-4.627-5.886l2.104-8.417l-0.419-7.992l2.523-7.994l9.254-1.683l-3.367-9.679l-0.844-7.991l6.311-12.621v-13.463l-1.262-25.66
		l2.524-5.892l-2.099-7.573l5.886-5.888l-1.682-10.099l-2.942-6.309l-0.844-10.097l2.944-6.732l3.366-3.365l-3.786-5.89
		l-1.265-6.311l6.73-2.946l6.737-11.78l-1.263-6.312l-3.368,0.843l-2.107-3.368l-0.416-5.048l-5.47-9.676l-2.948-11.78l2.522-13.042
		l7.155-4.629l11.357,0.421l14.729,10.097l4.205,7.149l1.681,6.732l12.62,0.42l3.366-2.523v-5.049l5.895-2.523l6.729-8.834
		l0.844-9.256l2.524-5.049l-7.15-9.255l-5.894-10.937l3.785-7.154c0,0,3.788-4.625,0-6.729c-3.785-2.106-4.624-7.574-4.624-7.574
		l9.254-2.524l3.944-1.778l5.731-0.748l2.525-9.675l4.624-0.422v-14.025l13.187,14.028l4.21-0.565l2.239,8.699l4.773,3.364
		l5.887,0.842v7.854l-3.644,10.096l-7.292-9.678l-5.474-0.418l-4.207,4.628l-3.785,2.945l3.367,6.731l2.104,9.675l0.42,15.144
		l5.892,1.264l1.683,6.309l-0.908,8.863l-2.879,10.908l-2.941,7.575v6.732l-7.999,4.207l-2.941,7.571l-3.371,5.05l-1.679,12.621
		l1.259,10.938l2.946,10.937l-9.255,31.976l-16.405,42.069l-3.788,7.573l-2.104,12.202l-6.371,8.984l0.748,1.501l1.832,4.235
		l-2.522,10.096l-6.813,13.81L500.179,507.023z"
              />
                                <title>BRIGADE D'INFANTERIE EST</title> */}
            </a>

            <a href="/brigade/12/effectifbrigade" onMouseOver={(e) => showTooltip(e, 12)} onMouseOut={hideTooltip}>
              <path
                id="path5420"
                fill="#E32923"
                stroke="#000000"
                d="M421.929,603.788l0.631-5.893l6.943-0.843l3.994-3.364l-1.683-5.685
		l-2.737-0.837l9.678-5.474l-1.263-7.779l3.153-13.884l-2.729-3.784l-1.264-4.42l3.787-3.785l0.211-5.682l-5.469-1.05l0.42-6.104
		l6.518-0.843l0.211-11.985l10.521,0.207l-0.634-6.099l3.154-10.522l-3.154-5.252l2.104-8.417l-0.419-7.992l2.524-7.996l9.254-1.683
		l-3.369-9.68l-13.04-2.099l-1.681-5.473l-2.117-3.792l-6.717-2.094l-9.68-6.735h-6.312l-1.683-3.362l-0.843-8.833l2.946-10.521
		v-12.199l-0.841-2.946l-3.369-2.942l-4.205-7.994l-8.416-1.264l-5.467-11.777l-0.422-10.938l-5.47-5.471l-4.626-13.461
		l-14.725,6.311l-4.63,0.422l-2.522-2.526l-6.731,0.839l-2.524,9.257l-10.519,4.206l-7.151,8.833l-2.104,0.423l2.523,10.938
		l-1.262,10.519l-3.786,3.786v11.359l5.47,9.672l3.364,10.521l8.416,1.682v10.514h-6.31l1.682,7.154l5.048,4.63l-1.682,7.99
		l1.262,5.468l-2.946,2.107l1.05,15.989l3.577,26.292l-2.945,4.418l-0.421,7.785l1.262,7.572l-2.733,3.575l0.208,7.784l-9.005,2.175
		l-0.882,7.924l-2.943,9.672l18.089,8.205l16.197-0.207l5.891,2.734l8.626,5.677v8.206l5.678,5.05l5.26,1.052l6.733,4.836
		L421.929,603.788z"
              />
              <title>BRIGADE D'INFANTERIE  CENTRE SUD</title>
            </a>

            <a href="/brigade/16/effectifbrigade" onMouseOver={(e) => showTooltip(e, 16)} onMouseOut={hideTooltip}>
              <path
                id="path5422"
                fill="#F3E512"
                stroke="#000000"
                d="M500.179,507.023l-10.097-8.836l-10.095-4.209l-5.468,9.26l-17.673,3.361
		l-1.472-0.631l-3.154,10.521l0.634,6.098l-10.519-0.208l0,0l-0.213,11.987l-6.518,0.842l-0.42,6.104l5.468,1.052l-0.211,5.681
		l-3.787,3.786l1.265,4.418l2.729,3.786l-3.153,13.883l1.262,7.778l-9.679,5.475l2.737,0.837l1.685,5.684l-3.996,3.365l-6.942,0.843
		l-0.423,11.144l3.362,4.416l2.738,10.524l-0.212,17.876l-3.571,10.31l-2.317-4.417l-7.865-2.283l-7.703,1.648l-0.213,4.208
		l4.001,6.102l-1.262,6.101l3.365,5.261l-3.787,14.089l0.842,1.053l-5.047,4l-4.21-0.634l-0.63-3.366l-7.993-0.838l-1.049-1.683
		l-4.628-1.899l0.629-5.674l3.367-1.897l-0.843-11.778l-8.2-5.469l-1.057-8.622l-16.406-14.098l-13.253,1.687l-13.252,5.889
		l-5.05,7.15l-1.051,7.785l0.629,9.466l-4.627,4.207c0,0-2.734,2.95-2.313,6.312c0.42,3.367,0.42,3.367,0.42,3.367h10.729
		l3.154,6.523l-2.312,9.04l-8.627,1.688l-4.625,5.262v4.41l-3.049,4.521l2.628,9.362l-6.102,9.68l2.523,10.311l-2.523,3.152
		l-0.42,6.523l-3.997,5.678l-7.572,6.942l-8.679,7.513l-4.155,4.053l-2.521,7.781l11.358,0.422l15.146,8.836l7.152,8.62l6.447-1.851
		l12.486,0.591l10.095-7.36l6.101-5.261l17.482-8.401l5.024-1.272l21.041-1.686l5.506-3.677l8.581-5.576l7.787-7.998l9.468-22.719
		l0.692-9.604l4.988-8.484l0,0l2.942-4.417l3.367-10.098l4.631-7.146l1.047-16.41l5.677-12.836l7.065-34.796l4.3-22.421l0,0
		l7.376-11.535l4.188-14.757l3.156-5.256l2.105-13.464l5.468-11.567l1.265-9.045l3.366-9.467l1.262-8.835l4.631-10.31
		L500.179,507.023z"
              />

                             <title>BRIGADE D'INFANTERIE SUD EST</title>  
            </a>

            <a href="/brigade/11/effectifbrigade" onMouseOver={(e) => showTooltip(e, 11)} onMouseOut={hideTooltip}>
              <path
                id="path5424"
                fill="#EB6823"
                stroke="#000000"
                d="M390.375,353.042l4.625,13.461l5.472,5.472l0.418,10.938l5.47,11.779
		l8.413,1.262l4.208,7.994l3.367,2.943l0.842,2.946v12.2l-2.944,10.519l0.84,8.834l1.684,3.362h6.313l4.63,2.525l5.051,4.211
		l6.718,2.095l2.117,3.792l1.682,5.473l13.04,2.099l-0.844-7.991l6.311-12.621v-13.463l-1.262-25.66l2.524-5.892l-2.099-7.573
		l5.886-5.888l-1.682-10.099l-2.942-6.309l-0.843-10.097l-2.944-5.05l-8.416,1.262l-8.834,5.471l-6.731,0.418l-5.047-6.729h-9.678
		l-8.415,4.627l-10.937-1.263l-1.686-5.048H390.375z"
              />
                               <title>BRIGADE D'INFANTERIE CENTRE</title> 
            </a>

            <path
              class="st28"
              d="M582.1,294.3c0,0-2.7,5.8-6.4,8.3c-3.7,2.5-6.6,4.3-6.7,8.6s-2.5,7.8-2.5,7.8s6.3,0.1,10.1-7.8
	C580.5,303.4,586.5,291.8,582.1,294.3z"
            />

            <a href="/brigade/19/effectifbrigade" onMouseOver={(e) => showTooltip(e, 19)} onMouseOut={hideTooltip}>
              <path
                fill="#2DE700"
                id="path5420_1_"
                class="st0"
                d="M449.1,462.1l-1.7-5.5l-2.1-3.8l-6.7-2.1l-9.7-6.7h-6.3l-1.7-3.4l-0.8-8.8l2.9-10.5v-12.2
	l-0.8-2.9l-3.4-2.9l-4.2-8l-8.4-1.3l-5.5-11.8l-0.4-10.9l-5.5-5.5l-4.6-13.5l-14.7,6.3l-4.6,0.4l-2.5-2.5l-6.7,0.8l-2.5,9.3
	l-10.5,4.2l-7.2,8.8l-2.1,0.4l2.5,10.9l-1.3,10.5l-3.8,3.8v11.4l5.5,9.7l3.4,10.5l8.4,1.7V449h-6.3l1.7,7.2l3.3,12.6l1.3,5.5
	L449.1,462.1z"
              />
            </a>
 
            <a href="/brigade/21/effectifbrigade" onMouseOver={(e) => showTooltip(e, 21)} onMouseOut={hideTooltip}>
              <text transform="matrix(1 0 0 1 651.4161 156.6754)" class="st29 st27">
                CORPS AUTONOMES
              </text>
            </a>
            <a href="/brigade/22/effectifbrigade" onMouseOver={(e) => showTooltip(e, 22)} onMouseOut={hideTooltip}>
              <text transform="matrix(1 0 0 1 651.4161 201.6098)" class="st29 st27">
                ECOLE
              </text>
            </a>
            <text transform="matrix(1 0 0 1 648.7139 85.5744)" class="st30 st29 st27">
              Autres détails
            </text>
            
            <circle fill="#EB6823" class="st31" cx="638.5" cy="152.9" r="8.4" />
            <circle fill="#EB6823" class="st31" cx="638.5" cy="197.9" r="8.4" />
          </svg>
        </div>

        {tooltip.display && (
          <div
            style={{
              position: 'absolute',
              left: tooltip.x + 5, // Positionne légèrement à droite du curseur
              top: tooltip.y + 5, // Positionne légèrement en dessous du curseur
              backgroundColor: '#FFF',
              color: '#000',
              padding: '10px',
              borderRadius: '5px',
              fontSize: '14px',
              whiteSpace: 'nowrap',
              zIndex: 1,
            }}
          >
            <table className=" animate__animated animate__pulse table table-bordered">
              <thead className="thead-dark">
                <tr>
                  <th>Brigade</th>
                  <th>OFF</th>
                  <th>S-OFF</th>
                  <th>ADL</th>
                  <th>PDL</th>
                  <th>TOTAL</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{tooltip.data.brigadeName}</td>
                  <td>{tooltip.data.OFF}</td>
                  <td>{tooltip.data['S-OFF']}</td>
                  <td>{tooltip.data.ADL}</td>
                  <td>{tooltip.data.PDL}</td>
                  <td>{tooltip.data.TOTAL}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
        {BrigadesPieChart ? (
          <div className="col-md-4">
            <BrigadesPieChart />
          </div>
        ) : (
          'Chargement en cours... '
        )}
      </div>
    </div>
  );
};

export default MadagascarMap;
